var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.TheHeaderMobile, {
    attrs: {
      "site-logo": _setup.siteLogo,
      search: _setup.searchData,
      "without-analyses-cart": _setup.withoutAnalysesCart,
      "analyses-count-in-cart": _setup.analysesCountInCart,
      "expert-url": _setup.expertUrl,
      "available-languages": _setup.availableLanguages,
      "town-select-url": _setup.townSelectUrl,
      projects: _setup.projects,
      "personal-area-url": _setup.personalAreaUrl,
      "data-qa": "the_header",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }